import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page",
  ref: "pageRef"
}
const _hoisted_2 = { class: "page_top_bg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "page_wrap" }
const _hoisted_5 = { class: "info_title" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.Info.pic
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Info.name), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Info.time), 1),
      _createElementVNode("div", {
        class: "content",
        innerHTML: _ctx.Info.content
      }, null, 8, _hoisted_7),
      _createElementVNode("div", {
        class: "back_btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleRouter && _ctx.handleRouter(...args)))
      }, "返回列表")
    ])
  ], 512))
}